import classNames from 'classnames';

type Props = {
  className?: string;
};

function FanRegister({ className }: Props) {
  return (
    <div className={classNames('pt-0 pb-12', className)}>
      <iframe
        src='/registration.html'
        title='Registration'
        className='w-full h-[1000px] border border-zinc-200 rounded shadow'
      />
    </div>
  );
}

export default FanRegister;
